import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { BackendDataShape, UsedAPI } from "api/config";
import CookieMonster from "api/CookieMonster";

export const pesudConditionStoreAPI = createApi({
  reducerPath: "pesudConditionStoreAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${UsedAPI}`,
    prepareHeaders: (headers) => {
      let token = CookieMonster.loadCookie("jwt");
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["PesudConditionList"],
  endpoints: (builder) => {
    return {
      getPesudCondition: builder.query<string[], object>({
        query: () => {
          let url = "/accidents/pesud-conditions";
          return {
            url,
            method: "GET",
          };
        },
        transformResponse: (response: BackendDataShape<string[]>) =>
          response.data,
        providesTags: ["PesudConditionList"],
      }),
    };
  },
});

export const {
  useGetPesudConditionQuery,
  util: { resetApiState: resetPesudConditionStoreAPI },
} = pesudConditionStoreAPI;
